export default "__VITE_ASSET__D_3wFc9X__"